import React, {Component} from "react";
import {FormattedMessage} from "react-intl";
import axios from "axios";
import {RESOURCE_BASE_URL} from "../../../../configuration";

class InquiriesPerUserTitleBar extends Component {

    constructor(props) {
        super(props);
        this.state = {
            email: ""
        };
    }
    getCustomerEmail() {
        axios.get(RESOURCE_BASE_URL + 'api/users/' + this.props.userId)
            .then((res) => {
                // console.log(res.data);
                this.setState({
                    email: res.data.email,

                });
            })
            .catch((err) => {
                console.log("[API] ERROR: ", err);
            });
    }

    componentDidMount() {
        this.getCustomerEmail();
    }


    render() {
        return (
            <div className="row">
                <div className="title-1 text-align-left">
                    <FormattedMessage id="app.inquiry-per-user-title.title"
                                      defaultMessage="INQUIRIES : "
                                      description=""/>
                    &nbsp;&nbsp;
                    {this.state.email}
                </div>
            </div>
        )
    }
}
export default InquiriesPerUserTitleBar;


// WEBPACK FOOTER //
// ./src/components/Admin/InquiriesPerUser/InquiriesPerUserTitleBar/InquiriesPerUserTitleBar.js